<template>
  <div class="goods-add-container">
    <!-- 主要内容区域 -->
    <div class="content-area">
      <el-row :gutter="24">
        <!-- 左侧：基本信息 -->
        <el-col :span="12">
          <el-card class="form-card" shadow="always">
            <div class="card-header">
              <h3 class="card-title">
                <i class="el-icon-goods"></i>
                基本信息
              </h3>
            </div>
            <el-form ref="item" :model="item" label-width="120px" class="goods-form">
              <!-- 基本信息 -->
              <div class="form-section">
                <h4 class="section-title">基本信息</h4>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="品牌名称" required>
                      <el-input 
                        v-model="item.brand" 
                        placeholder="请输入品牌名称" 
                        clearable
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="商品名称" required>
                      <el-input 
                        v-model="item.name" 
                        placeholder="请输入商品名称" 
                        clearable
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- 商品图片 -->
              <div class="form-section">
                <h4 class="section-title">商品图片</h4>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <div class="upload-item">
                      <label class="upload-label">到样图</label>
                      <el-upload
                        class="avatar-uploader"
                        action="http://47.108.21.146:7777/goods/upload"
                        :show-file-list="false"
                        :before-upload="beforePictureUpload"
                      >
                        <img v-if="item.picture" :src="item.picture" class="avatar">
                        <div v-else class="upload-placeholder">
                          <i class="el-icon-plus"></i>
                          <p>点击上传到样图</p>
                        </div>
                      </el-upload>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="upload-item">
                      <label class="upload-label">补样图</label>
                      <el-upload
                        class="avatar-uploader"
                        action="1111"
                        :show-file-list="false"
                        :before-upload="beforeSupplePictureUpload"
                      >
                        <img v-if="item.supplePicture" :src="item.supplePicture" class="avatar">
                        <div v-else class="upload-placeholder">
                          <i class="el-icon-plus"></i>
                          <p>点击上传补样图</p>
                        </div>
                      </el-upload>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <!-- 商品属性 -->
              <div class="form-section">
                <h4 class="section-title">商品属性</h4>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="商品属性">
                      <el-select 
                        v-model="item.properties" 
                        multiple 
                        filterable 
                        placeholder="请选择商品属性" 
                        style="width:100%"
                        size="medium"
                      >
                        <el-option
                          v-for="property in properties"
                          :key="property.value"
                          :label="property.label"
                          :value="property.value"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="所属店铺">
                      <el-input 
                        v-model="item.shop" 
                        placeholder="请输入商品所属店铺" 
                        clearable
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="商品位置">
                      <el-input 
                        v-model="item.location" 
                        placeholder="请输入商品位置" 
                        clearable
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="型号/规格">
                      <el-input 
                        v-model="item.specs" 
                        placeholder="请输入型号/规格信息" 
                        clearable
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="商品描述">
                  <el-input 
                    type="textarea" 
                    placeholder="请输入商品描述" 
                    v-model="item.description" 
                    :maxlength="textMaxLenth" 
                    autosize
                    size="medium"
                  />
                </el-form-item>
              </div>

              <!-- 价格信息 -->
              <div class="form-section">
                <h4 class="section-title">价格信息</h4>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="日常价格">
                      <el-input 
                        v-model="item.highPrice" 
                        placeholder="请输入日常价格" 
                        clearable
                        size="medium"
                      >
                        <template slot="append">元</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="直播价格">
                      <el-input 
                        v-model="item.lowPrice" 
                        placeholder="请输入直播价格" 
                        clearable
                        size="medium"
                      >
                        <template slot="append">元</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <!-- 时间信息 -->
              <div class="form-section">
                <h4 class="section-title">时间信息</h4>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="到样时间">
                      <el-date-picker 
                        v-model="item.arrivalTime" 
                        type="date" 
                        placeholder="选择到样日期" 
                        style="width:100%"
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="到期时间">
                      <el-date-picker 
                        v-model="item.exp" 
                        type="date" 
                        placeholder="选择过期日期" 
                        style="width:100%"
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="到样总数">
                  <el-input 
                    type="textarea" 
                    placeholder="请输入到样总数信息" 
                    v-model="item.num" 
                    :maxlength="textMaxLenth" 
                    autosize
                    size="medium"
                  />
                </el-form-item>
              </div>

              <!-- 商品详情 -->
              <div class="form-section">
                <h4 class="section-title">商品详情</h4>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="材质/香型">
                      <el-input 
                        type="textarea" 
                        placeholder="请输入材质/香型信息" 
                        v-model="item.material" 
                        :maxlength="textMaxLenth" 
                        autosize
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="颜色/口味">
                      <el-input 
                        type="textarea" 
                        placeholder="请输入颜色/口味信息" 
                        v-model="item.color" 
                        :maxlength="textMaxLenth" 
                        autosize
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="赠品信息">
                  <el-input 
                    type="textarea" 
                    v-model="item.gifts" 
                    placeholder="请输入赠品信息" 
                    :maxlength="textMaxLenth" 
                    autosize
                    size="medium"
                  />
                </el-form-item>
              </div>
              <!-- 试样信息 -->
              <div class="form-section">
                <h4 class="section-title">试样信息</h4>
                <el-form-item label="通过试样">
                  <el-row :gutter="20" align="middle">
                    <el-col :span="4">
                      <el-switch 
                        v-model="item.pass"
                        active-text="通过"
                        inactive-text="未通过"
                      />
                    </el-col>
                    <el-col :span="20">
                      <el-input 
                        type="textarea" 
                        placeholder="请输入试样备注信息" 
                        v-model="item.tryDetails" 
                        :maxlength="textMaxLenth" 
                        autosize
                        size="medium"
                      />
                    </el-col>
                  </el-row>
                </el-form-item>
              </div>

              <!-- 已有资源 -->
              <div class="form-section">
                <h4 class="section-title">已有资源</h4>
                <el-form-item label="已拥有资源">
                  <el-checkbox-group v-model="item.has" class="checkbox-group">
                    <el-checkbox label="卖点卡" name="sellingPointCards">卖点卡</el-checkbox>
                    <el-checkbox label="商家卖点卡" name="merchantSellingPointCards">商家卖点卡</el-checkbox>
                    <el-checkbox label="比价图" name="PriceComparisonChart">比价图</el-checkbox>
                    <el-checkbox label="辅助文件" name="auxiliaryFiles">辅助文件</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>

              <!-- 附件上传 -->
              <div class="form-section">
                <h4 class="section-title">附件上传</h4>
                <el-form-item label="相关附件">
                  <el-upload
                    class="upload-demo"
                    action="http://47.108.21.146:7777/goods"
                    :before-upload="handleBeforeUpload"
                    :on-remove="handleRemove"
                    :on-preview="handlePreview"
                    :before-remove="beforeRemove"
                    :file-list="item.fileList"
                    multiple
                  >
                    <el-button size="medium" type="primary" icon="el-icon-upload">
                      点击上传附件
                    </el-button>
                    <div slot="tip" class="el-upload__tip">
                      支持上传多个文件，单个文件不超过10MB
                    </div>
                  </el-upload>
                </el-form-item>
              </div>

              <!-- 操作按钮 -->
              <div class="form-actions">
                <el-button type="primary" size="large" @click="onSubmit" icon="el-icon-check">
                  立即创建
                </el-button>
                <el-button size="large" @click="resetForm" icon="el-icon-refresh">
                  重置表单
                </el-button>
              </div>
            </el-form>
          </el-card>
        </el-col>

        <!-- 右侧：补样和退样信息 -->
        <el-col :span="12">
          <el-card class="form-card" shadow="always">
            <div class="card-header">
              <h3 class="card-title">
                <i class="el-icon-refresh"></i>
                补样和退样信息
              </h3>
            </div>
            <el-form ref="suppleForm" :model="item" label-width="100px" class="supple-form">
              <!-- 补样信息 -->
              <div class="form-section">
                <h4 class="section-title">补样信息</h4>
                <el-form-item label="补样时间">
                  <el-date-picker 
                    v-model="item.suppleTime" 
                    type="date" 
                    placeholder="选择补样日期" 
                    style="width:100%"
                    size="medium"
                  />
                </el-form-item>
                <el-form-item label="补样数量">
                  <el-input 
                    type="textarea" 
                    placeholder="请输入补样数量信息" 
                    v-model="item.suppleNum" 
                    :maxlength="textMaxLenth" 
                    autosize
                    size="medium"
                  />
                </el-form-item>
                <el-form-item label="补样备注">
                  <el-input 
                    type="textarea" 
                    placeholder="请输入补样备注信息" 
                    v-model="item.suppleDetails" 
                    :maxlength="textMaxLenth" 
                    autosize
                    size="medium"
                  />
                </el-form-item>
              </div>

              <!-- 退样信息 -->
              <div class="form-section">
                <h4 class="section-title">退样信息</h4>
                <el-form-item label="退样时间">
                  <el-date-picker 
                    v-model="item.returnTime" 
                    type="date" 
                    placeholder="选择退样日期" 
                    style="width:100%"
                    size="medium"
                  />
                </el-form-item>
                <el-form-item label="退样地址">
                  <el-input 
                    v-model="item.returnAddress" 
                    placeholder="请输入退样地址" 
                    clearable
                    size="medium"
                  />
                </el-form-item>
                <el-form-item label="退样单号">
                  <el-input 
                    v-model="item.returnNumber" 
                    placeholder="请输入退样单号" 
                    clearable
                    size="medium"
                  />
                </el-form-item>
                <el-form-item label="退样备注">
                  <el-input 
                    type="textarea" 
                    placeholder="请输入退样备注信息" 
                    v-model="item.returnDetails" 
                    :maxlength="textMaxLenth" 
                    autosize
                    size="medium"
                  />
                </el-form-item>
                <el-form-item label="退样图片">
                  <el-upload
                    class="upload-demo"
                    action="http://47.108.21.146:7777/goods"
                    :on-remove="handleReturnRemove"
                    :on-preview="handlePreview"
                    :before-remove="beforeReturnRemove"
                    :before-upload="handleReturnBeforeUpload"
                    :file-list="item.returnFileList"
                    multiple
                  >
                    <el-button size="medium" type="primary" icon="el-icon-upload">
                      点击上传退样图片
                    </el-button>
                    <div slot="tip" class="el-upload__tip">
                      支持上传多个图片文件
                    </div>
                  </el-upload>
                </el-form-item>
              </div>
            </el-form>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { goodsApi } from '@/api'

export default {
  name: 'GoodsAdd',
  data () {
    return {
      item: {
        brand: '',
        name: '',
        properties: [],
        highPrice: '',
        picture: '',
        supplePicture: '',
        lowPrice: '',
        shop: '',
        location: '',
        exp: '',
        gifts: '',
        description: '',
        arrivalTime: '',
        num: '',
        specs: '',
        material: '',
        color: '',
        tryDetails: '',
        pass: false,
        scheduledFrom: '',
        scheduledTo: '',
        has: [],
        suppleTime: '',
        suppleNum: '',
        suppleDetails: '',
        returnFileList: [],
        returnTime: '',
        returnAddress: '',
        returnNumber: '',
        returnDetails: '',
        fileList: []
      },
      properties: [],
      textMaxLenth: 300
    }
  },
  mounted () {
    this.getProperty()
  },
  methods: {
    // 返回商品列表
    goBack () {
      this.$router.go(-1)
    },

    async getProperty () {
      try {
        const response = await goodsApi.getProperty()
        this.properties = response
      } catch (error) {
        console.error('获取属性失败:', error)
      }
    },
    async onSubmit () {
      try {
        await goodsApi.saveGoods(this.item)
        this.$message.success('保存商品成功！')
        this.resetForm()
      } catch (error) {
        console.error('保存商品失败:', error)
      }
    },
    resetForm () {
      Object.assign(this.$data, this.$options.data())
    },
    handleRemove (file) {
      for (var i = 0; i < this.item.fileList.length; i++) {
        if (this.item.fileList[i].uid === file.uid) {
          this.item.fileList.splice(i, 1)
          i--
        }
      }
    },
    async handleBeforeUpload (file) {
      if (file.size / 1024 / 1024 > 10) {
        this.$message.error('上传图片大小不能超过 10MB!')
        return
      }
      try {
        const response = await goodsApi.uploadFile(file)
        this.$message.success('文件上传成功！')
        let addFile = {
          'name': file.name,
          'url': response
        }
        this.item.fileList.push(addFile)
      } catch (error) {
        console.error('文件上传失败:', error)
      }
    },
    beforeRemove (file) {
      return this.$confirm('确定移除' + file.name + '?')
    },
    handleReturnRemove (file) {
      for (var i = 0; i < this.item.returnFileList.length; i++) {
        if (this.item.returnFileList[i].uid === file.uid) {
          this.item.returnFileList.splice(i, 1)
          i--
        }
      }
    },
    async handleReturnBeforeUpload (file) {
      if (file.size / 1024 / 1024 > 10) {
        this.$message.error('上传图片大小不能超过 10MB!')
        return
      }
      try {
        const response = await goodsApi.uploadFile(file)
        this.$message.success('文件上传成功！')
        let addFile = {
          'name': file.name,
          'url': response
        }
        this.item.returnFileList.push(addFile)
      } catch (error) {
        console.error('文件上传失败:', error)
      }
    },
    beforeReturnRemove (file) {
      return this.$confirm('确定移除' + file.name + '?')
    },
    handlePreview (file) {
      window.open(file.url)
    },
    async beforePictureUpload (file) {
      if (!this.vaildPicture(file)) return
      try {
        const response = await goodsApi.uploadFile(file)
        this.$message.success('文件上传成功！')
        this.item.picture = response
      } catch (error) {
        console.error('文件上传失败:', error)
      }
    },
    async beforeSupplePictureUpload (file) {
      if (!this.vaildPicture(file)) return
      try {
        const response = await goodsApi.uploadFile(file)
        this.$message.success('文件上传成功！')
        this.item.supplePicture = response
        this.$forceUpdate()
      } catch (error) {
        console.error('文件上传失败:', error)
      }
    },
    vaildPicture (file) {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png')
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 或者 PNG 格式!')
        return
      }
      if (!isLt10M) {
        this.$message.error('上传图片大小不能超过 10MB!')
        return
      }
      return isJPG && isLt10M
    }
  }
}
</script>

<style scoped>
/* 主容器 */
.goods-add-container {
  padding: 40px;
  background-color: #ffffff;
  min-height: 100vh;
}

/* 页面头部 */
.page-header {
  background: linear-gradient(135deg, #409EFF 0%, #337ECC 100%);
  border-radius: 12px;
  margin-bottom: 24px;
  overflow: hidden;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px;
  color: white;
}

.header-left .page-title {
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-left .page-subtitle {
  font-size: 14px;
  margin: 0;
  opacity: 0.9;
}

/* 内容区域 */
.content-area {
  max-width: 1600px;
  margin: 0 auto;
}

/* 表单卡片 */
.form-card {
  border-radius: 16px;
  margin-bottom: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.card-header {
  padding: 30px 0;
  border-bottom: 2px solid #EBEEF5;
  margin-bottom: 30px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px 16px 0 0;
}

.card-title {
  font-size: 22px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* 表单样式 */
.goods-form, .supple-form, .return-form {
  padding: 0 40px 40px;
}

.form-section {
  margin-bottom: 40px;
  padding: 30px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  border-left: 6px solid #409EFF;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.form-section:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 25px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-title::before {
  content: '';
  width: 6px;
  height: 20px;
  background: linear-gradient(135deg, #409EFF 0%, #66B1FF 100%);
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
}

/* 上传组件 */
.upload-item {
  text-align: center;
}

.upload-label {
  display: block;
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
  font-weight: 500;
}

.avatar-uploader .el-upload {
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  height: 150px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
  background-color: #f0f9ff;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #8c939d;
}

.upload-placeholder i {
  font-size: 32px;
  margin-bottom: 8px;
}

.upload-placeholder p {
  font-size: 12px;
  margin: 0;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 复选框组 */
.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.checkbox-group .el-checkbox {
  margin-right: 0;
}

/* 操作按钮 */
.form-actions {
  text-align: center;
  padding: 40px 0;
  border-top: 2px solid #EBEEF5;
  margin-top: 30px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 0 0 16px 16px;
}

.form-actions .el-button {
  margin: 0 15px;
  min-width: 150px;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.form-actions .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .content-area .el-col {
    margin-bottom: 20px;
  }
}

@media (max-width: 768px) {
  .goods-add-container {
    padding: 10px;
  }
  
  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
  
  .form-section {
    padding: 15px;
  }
  
  .checkbox-group {
    flex-direction: column;
    gap: 10px;
  }
  
  .form-actions .el-button {
    width: 100%;
    margin: 5px 0;
  }
}

/* Element UI 组件样式优化 */
.el-form-item__label {
  font-weight: 500;
  color: #606266;
}

.el-input__inner, .el-textarea__inner {
  border-radius: 6px;
}

.el-button {
  border-radius: 6px;
}

.el-card {
  border-radius: 12px;
}

.el-upload__tip {
  color: #909399;
  font-size: 12px;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/goods/GoodsAdd.vue